import styled from 'styled-components';
import { Column } from '@simplywallst/ui-core';

export const SectionColumn = styled(Column)`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  margin-right: ${({ theme }) => theme.x2spacePx}px;
  ${({ theme }) => theme.typography.baseStrong}
  color: ${({ theme }) => theme.color.spaceGray};
  > p {
    ${({ theme }) => theme.typography.small}
  }
`;

export const Header = styled.header`
  margin-bottom: 4px;
  ${({ theme }) => theme.typography.xSmallStrong}
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.8)};
`;

export const SecondaryText = styled.span`
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.5)};
  margin: 0 4px;
`;

export const SecondaryTextSmall = styled(SecondaryText)`
  ${({ theme }) => theme.typography.small}
  margin: 0 5px 0 0;
`;
